import React, { useRef, useEffect } from 'react';

const QCReportModal = ({ selectedReport, onClose }) => {
	const modalRef = useRef();

	useEffect(() => {
		const modal = new window.bootstrap.Modal(modalRef.current);
		modal.show();

		modalRef.current.addEventListener('hidden.bs.modal', onClose);

		return () => {
			if (modalRef.current) {
				modalRef.current.removeEventListener('hidden.bs.modal', onClose);
				const modal = window.bootstrap.Modal.getInstance(modalRef.current);
				if (modal) modal.hide();
			}
		};
	}, [selectedReport]);

	console.log(selectedReport);

	return (
		<div
			className="modal fade"
			tabIndex="-1"
			ref={modalRef}
			id={`reportModal${selectedReport.id}`}
			style={{ marginTop: '80px' }}
		>
			<div
				className="modal-dialog"
				style={{ width: '70vw', marginLeft: '15%' }}
			>
				<div className="modal-content" style={{ width: '70vw' }}>
					<div
						className="modal-header text-light"
						style={{ backgroundColor: 'rgb(48, 48, 48)' }}
					>
						<h4
							className="modal-title"
							id={`reportModal${selectedReport.id}Label`}
						>
							Report {selectedReport.id}
						</h4>
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						></button>
					</div>

					<div className="modal-body">
						<div className="row">
							<div className="col-6">
								<table
									className="table px-5 table-borderless"
									style={{ width: '60%', marginLeft: '20%' }}
								>
									<thead>
										<tr>
											<th className="text-center" colSpan={2}>
												General Info
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Report ID</td>
											<td>{selectedReport.id}</td>
										</tr>

										<tr>
											<td>User</td>
											<td>{selectedReport.user}</td>
										</tr>

										<tr>
											<td>Commodity</td>
											<td>{selectedReport.commodity}</td>
										</tr>

										<tr>
											<td>QC Type</td>
											<td>{selectedReport.qcType}</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="col-6">
								<table
									className="table px-5 table-borderless"
									style={{ width: '60%', marginLeft: '20%' }}
								>
									<thead>
										<tr>
											<th className="text-center" colSpan={2}>
												Queue Info
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Queue ID</td>
											<td>{selectedReport.queueID}</td>
										</tr>

										<tr>
											<td>Record ID</td>
											<td>{selectedReport.recordID}</td>
										</tr>

										<tr>
											<td>Queue created</td>
											<td>
												{selectedReport.queueCreatedDate}{' '}
												{selectedReport.queueCreatedTime}
											</td>
										</tr>

										<tr>
											<td>No. caps in queue</td>
											<td>{selectedReport.capsInQueue.length}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div className="row">
							<div className="col-6">
								<table
									className="table px-5 table-borderless"
									style={{ width: '60%', marginLeft: '20%' }}
								>
									<thead>
										<tr>
											<th className="text-center" colSpan={2}>
												QC Info
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Caps QC'd</td>
											<td>{selectedReport.capsQCd.length}</td>
										</tr>

										<tr>
											<td>Caps Auto-QC'd</td>
											<td>{selectedReport.capsAutoQCd.length}</td>
										</tr>

										<tr>
											<td>Caps not QC'd</td>
											<td>{selectedReport.capsNotQCd.length}</td>
										</tr>

										<tr>
											<td>Agree / Disagree Ratio</td>
											<td>
												{selectedReport.agreeDisagreeRatio.agree} /{' '}
												{selectedReport.agreeDisagreeRatio.disagree}
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="col-6">
								<table
									className="table px-5 table-borderless"
									style={{ width: '60%', marginLeft: '20%' }}
								>
									<thead>
										<tr>
											<th className="text-center" colSpan={2}>
												Post-QC Info
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Post-QC Started</td>
											<td>{selectedReport.postQCStarted}</td>
										</tr>

										<tr>
											<td>Post-QC Data</td>
											{selectedReport.postQCStarted ? (
												<td>
													Captures {selectedReport.postQCData.captures} /
													Sites {selectedReport.postQCData.sites}
												</td>
											) : (
												<td>-</td>
											)}
										</tr>

										<tr>
											<td>Upload Started</td>
											<td>
												{selectedReport.uploadStarted}
											</td>
										</tr>

										<tr>
											<td>Upload Completed</td>
											<td>{selectedReport.uploadedCompleted}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QCReportModal;
